import { FC } from 'react';
import Link from 'next/link';
import { getBookNoun, getTruncatedTxt } from '@/helpers/helpers';
import { ICollectionsData } from '@/interfaces/collections.interface';
import CollectionLike from '../collection-like/CollectionLike';
import { DEV_ABSOLUTE_URL } from '@/helpers/variables';
import styles from './CollectionItem.module.scss';

interface CollectionItemProps {
  item: ICollectionsData;
  extraClassName?: string;
}

const CollectionItem: FC<CollectionItemProps> = ({ item, extraClassName }) => {
  const collectionAlias = `/collections/${item?.alias}/`;

  return (
    <div className={extraClassName ? `${styles.collectionItem} ${styles[`${extraClassName}`]}` : `${styles.collectionItem}`}>
      <div className={styles.collectionItem__wrap}>
        <div className={styles.collectionItem__infoWrap}>
          <Link prefetch={false} href={collectionAlias} className={styles.collectionItem__imgWrap}>
            <span className={styles.collectionItem__booksCover}>
              <img src={`${DEV_ABSOLUTE_URL}/covers/${item.books_external_id_list[0]}.jpg`} className={styles.collectionItem__defaultCover} style={{ backgroundImage: `linear-gradient(rgba(1, 15, 53, 0.2) 0%, rgba(1, 15, 53, 0.4) 100%)` }} />
              <span className={styles.collectionItem__defaultImgs}>
                {item.books_external_id_list.map((imgItem: string) => (
                  <img key={imgItem} src={`${DEV_ABSOLUTE_URL}/covers/${imgItem}.jpg`} className={styles.collectionItem__defaultImg} alt="img" />
                ))}
              </span>
            </span>
          </Link>
          <div className={styles.collectionItem__info}>
            <Link prefetch={false} href={collectionAlias} className={styles.collectionItem__title}>
              {item.title}
            </Link>

            <div className={styles.collectionItem__desc}>{getTruncatedTxt(item.description, 250)}</div>

            <ul className={styles.collectionItem__signs}>
              <li>
                <Link prefetch={false} href={collectionAlias} className={styles.collectionItem__btn}>
                  Подробнее
                </Link>
              </li>
              <li className={`${styles.collectionItem__signItem} ${styles.collectionItem__signItem_books}`}>{`${item.books} ${getBookNoun(item.books ?? 0)}`}</li>
              <CollectionLike votes={item.voted_users} id={item.id} />
              <li className={`${styles.collectionItem__signItem} ${styles.collectionItem__signItem_reviews}`}>{item.reviews}</li>
            </ul>
          </div>
        </div>
      </div>
    </div>
  );
};
export default CollectionItem;
